import { DEFAULT_COLORS } from '@components/widgets/apacheEchart/Commons'
import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, msurPorcRespuestasMapper, msurTooltipTotalRegistros } from '../commonWidgetsMedicasur'


const GROUP_LABELS_PERSONAL = {
    //'exp_hosp_enfermeria_trato': 'Enfermeria',
    'serv_neurof_estudios_trato': 'Médicos',
    'serv_neurof_recep_trato': 'Admisión',
    //'exp_hosp_camilleros_trato': 'Camilleros',
    'serv_neurof_inst_confort': 'Instalaciones',
    //'exp_hosp_nutricion_informacion': 'Nutricion'
}

const GROUP_LABELS_ADMISION = {
    'serv_neurof_recep_trato': 'Trato',
    //'exp_hosp_admision_espera': 'Agilidad del registro',
    'serv_neurof_recep_tiempo': 'Agilidad y atención del alta',
    'serv_neurof_recep_informacion': 'Claridad de la información'
}

//const GROUP_LABELS_ENFERMERIA = {
//    'exp_hosp_enfermeria_trato': 'Trato',
//    'serv_cidyt_enfermeria_privacidad': 'Privacidad, seguridad y respeto',
//    'serv_clin_enfermeria_explicacion': 'Explicación clara en la atención',
//    'exp_hosp_enfermeria_atencion': 'Atención oportuna'
//}

const GROUP_LABELS_PERSONAL_MEDICO = {
    'serv_neurof_estudios_trato': 'Trato',
    'serv_neurof_recep_estudios_privacidad': 'Privacidad, seguridad y respeto',
    //'serv_clin_prof_explicacion': 'Claridad en la información',
    'serv_neurof_estudios_profecionalismo': 'Lo toma en cuenta',
    //'exp_hosp_medico_atencion': 'Atención oportuna'
}

//const GROUP_LABELS_NUTRICION = {
    //'': 'Atención por la nutrióloga',
//    'exp_hosp_nutricion_sabor': 'Temperatura y presentación de los alimentos',
//    'exp_hosp_nutricion_informacion': 'Información sobre dieta'
//}

//const GROUP_LABELS_CAMILLERO = {
//    'exp_hosp_camilleros_trato': 'Trato y Tiempo de espera'
//}

//const GROUP_LABELS_PACIENTES_Y_FAMILIARES = {
//    'exp_hosp_paciente_estadia': 'Trato y Apoyo',
    //'': 'Explicación clara',
//    'exp_hosp_paciente_informacion': 'Utilidad de la guía de ingreso'
//}

const GROUP_LABELS_INSTALACIONES = {
    //'exp_hosp_instalaciones_calidad': 'Calidad en general de las instalaciones',
    //'': 'Calidad de las habitaciones',
    'serv_neurof_inst_confort': 'Calidad y Confort del inmobiliario'
}

const GROUP_LABELS_LIMPIEZA = {
    'serv_neurof_limp_general': 'Limpieza de las instalaciones',
    //'': 'Limpieza de las habitaciones',
    //'serv_cidyt_instalacion_limpieza_consultorio': 'Limpieza de las consultorios'
}


export default {
    title: 'Neurofisiología Dashboard',
    description: 'Dashboard del area de diagnóstico Neurofisiología',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        return [
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General',
                size: [2, 2],
                indicator: 'serv_neurof_csat',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_neurof_nps',
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Por qué seleccionó nuestro Hospital?',
                size: [3, 2],
                indicator: 'serv_neurof_motivo_eleccion',
                extraConfigs: {
                    decimals: 0
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGenericByStatus',
                title: 'Porcentaje de respuestas',
                indicator: 'general-respuestas-gauge',
                mapper: msurPorcRespuestasMapper,
                tooltipFormatter: msurTooltipTotalRegistros,
                size: [1, 2],
                url: 'dashboard/status',
                extraIndicatorConfigs: {
                    keyExtract: ['resume'],
                    singleton: true
                },
                extras: {
                    useLcmApi: true,
                    workflowName: 'serv_neurofisiologia'
                },
                extraConfigs: {
                    showPercentage: true,
                }
            }),
            
            
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción por Tipo de Personal',
                key: 'bar-by-question-personal',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_PERSONAL,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_PERSONAL).join(","),
                },
                size: [4, 2],
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia Admisión',
                key: 'bar-by-question-admision',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_ADMISION,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_ADMISION).join(","),
                },
                size: [2, 2],
            }),
            /*
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia Enfermería',
                key: 'bar-by-question-enfermeria',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_ENFERMERIA
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_ENFERMERIA).join(","),
                },
                size: [2, 2],
            }),
            */
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia el Personal Médico',
                key: 'bar-by-question-personal-medico',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_PERSONAL_MEDICO,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_PERSONAL_MEDICO).join(","),
                },
                size: [2, 2],
            }),
            /*
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia Nutrición',
                key: 'bar-by-question-nutricion',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_NUTRICION,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_NUTRICION).join(","),
                },
                size: [2, 2],
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia Camilleros',
                key: 'bar-by-question-camillero',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_CAMILLERO,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_CAMILLERO).join(","),
                },
                size: [2, 2],
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia Servicios a Pacientes y Familiares',
                key: 'bar-by-question-pacientes-familiares',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_PACIENTES_Y_FAMILIARES,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_PACIENTES_Y_FAMILIARES).join(","),
                },
                size: [4, 2],
            }),
            */
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia las Instalaciones',
                key: 'bar-by-question-instalaciones',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_INSTALACIONES,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_INSTALACIONES).join(","),
                },
                size: [2, 2],
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia la Limpieza',
                key: 'bar-by-question-limpieza',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_LIMPIEZA,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_LIMPIEZA).join(","),
                },
                size: [2, 2],
            }),










            {
                title: 'Recepción',
                type: 'label',
                size: [4, 0.5],
                config: { color: '#B7AADC' },
            },
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Información brindada por el personal',
                size: [1, 2],
                indicator: 'serv_neurof_recep_informacion',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Atención puntual',
                size: [1, 2],
                indicator: 'serv_neurof_recep_puntualidad',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Tiempo de espera',
                size: [1, 2],
                indicator: 'serv_neurof_recep_tiempo',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Cita telefónica',
                size: [1, 2],
                indicator: 'serv_neurof_recep_cal_cita_tel',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),


            {
                title: 'Instalaciones y Limppieza',
                type: 'label',
                size: [4, 1],
                //config: { color: '#B7AADC' },
            },
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Confort instalaciones',
                size: [2, 2],
                indicator: 'serv_neurof_inst_confort',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Limpieza general',
                size: [2, 2],
                indicator: 'serv_neurof_limp_general',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            {
                title: 'Gráfico de estudios',
                type: 'label',
                size: [4, 1],
                //config: { color: '#B7AADC' },
            },

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'UNIDAD DE ESTUDIOS',
                size: [4, 2],
                indicator: 'unidad_imagenologia',
                criticalMomentInclude: [12153],
                extras: {
                    formula: 'count-text',
                },
            }),

            {
                title: 'Experiencia y Recomendaciones',
                type: 'label',
                size: [4, 1],
                //config: { color: '#B7AADC' },
            },

            /*
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'wordCount',
                title: 'Comentarios',
                size: [2, 3],
                indicator: 'WORD_COUNT',

            }),
            */
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'lastComments',
                size: [4, 2],
                indicator: 'COMMENTS',
                extraConfigs: {
                    maxCommentSize: 120
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'textAnalysis',
                title: 'Clasificación Mande',
                size: [4, 3],
                indicator: 'SENTIMENT'
            }),
        ]
    },
} as DasboardConfig
